import React, { useState } from "react";
import "./AddCourtPopup.css"; // <-- we will style here
export default function AddCaseStatusPopup({ onAddStatus }) {
  const [showPopup, setShowPopup] = useState(false);
  const [newStatus, setNewStatus] = useState({ courtName: "", location: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onAddStatus(newStatus); // call parent function
    setNewStatus({ StatusName: ""});
    setShowPopup(false);
  };

  return (
    <div>
      {/* Button to open popup */}
      <button onClick={() => setShowPopup(true)}>Add Court Status</button>

      {/* Popup */}
      {showPopup && (
        <div className="popup-overlay">
            <div className="popup-container">
            <h2 className="popup-title">Add Court</h2>
            <form onSubmit={handleSubmit} className="popup-form">              
              <input
                type="text"
                placeholder="Case Status"
                value={newStatus.StatusName}
            onChange={(e) =>
                  setNewStatus({ ...newStatus, StatusName: e.target.value })
                }
                required
                style={{ display: "block", margin: "10px 0", width: "100%" }}
              />
              <div className="popup-buttons">
                <button type="submit" className="btn-save">Save</button>
                <button type="button" className="btn-cancel" onClick={() => setShowPopup(false)} style={{ marginLeft: "10px" }}>Cancel</button>                
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
